import { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";

class WorkInProgressScreen extends Component {
  render() {
    const { isLoggedIn } = this.props;
    return (
      <div className="d-flex flex-column min-vh-100">
        {/* TOP: Header */}
        <Header isLoggedIn={isLoggedIn} />

        {/* MIDDLE: Content Area */}
        <main className="flex-grow-1 d-flex justify-content-center align-items-center py-5">
          <div className="container text-center px-4">
            {/*Looping GIF */}
            <img
              src="/assets/misc/wip_illustration.gif"
              alt="Work in Progress"
              className="img-fluid mb-4"
              style={{
                pointerEvents: "none",
                userSelect: "none",
                maxHeight: "400px",
              }}
            />

            <h1
              className="display-5 text-dark mb-3"
              style={{ letterSpacing: "-1px" }}
            >
              Work in Progress
            </h1>

            <p
              className="lead text-secondary mx-auto mb-0"
              style={{
                maxWidth: "600px",
              }}
            >
              We are actively building this page and will have it ready for you
              soon.
            </p>
          </div>
        </main>

        {/* BOTTOM: Footer */}
        <Footer />
      </div>
    );
  }
}

export default WorkInProgressScreen;
